import { render, staticRenderFns } from "./MessageFile.vue?vue&type=template&id=b39eeb5c&scoped=true&"
import script from "./message-file.ts?vue&type=script&lang=ts&"
export * from "./message-file.ts?vue&type=script&lang=ts&"
import style0 from "./MessageFile.vue?vue&type=style&index=0&id=b39eeb5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b39eeb5c",
  null
  
)

export default component.exports